// AtherosclerosisCard.jsx

import React from "react";
import BasePackageCard from "./BasePackageCard";
import { ATHERO } from "../../../../constants";
import { useTranslation } from "../../../../language";

export default function AtherosclerosisCard() {
  const { t } = useTranslation();

  const panel = {
    id: "atherosclerosis",
    title: t("card_athero_title"),
    subtitle: t("card_athero_desc"),
    biomarkers: t("card_athero_markers"),
    price: "€ 149",
    image: ATHERO,
  };

  return <BasePackageCard panel={panel} />;
}